module.exports = __webpack_public_path__ + "img/pic4@3x.ad79759f.png";